module.exports = __webpack_public_path__ + "assets/pdf/E10-cn-correcting-urban-bias.44b2a8ce.pdf";